import { Box } from "@react-three/flex";
import { useRef } from "react";
import BioFlex from "../Flexes/BioFlex";
import GeoFlex from "../Flexes/GeoFlex";

function BioBox({ 
  align, 
  scale, 
  handleThreshold, 
  viewport,
}) {
  const groupRef = useRef();

  return(
    <>
      <Box
        flexDirection='column' 
        align={align} 
        justify='center'
        width='100%'
        height='auto'
      >
        <GeoFlex
          scale={scale}
          onReflow={handleThreshold}
          align='center'
          color='aqua'        
        />
          <BioFlex
            scale={scale}
            onReflow={handleThreshold}
            align='center'
            viewport={viewport}
          />
          <group ref={groupRef}>
            <GeoFlex
              scale={scale}
              onReflow={handleThreshold}
              align='center'
              color='red'
              cone        
            />
            <GeoFlex
              scale={scale}
              onReflow={handleThreshold}
              align='center'
              color='aqua'
              sphere        
            />
            <GeoFlex
              scale={scale}
              onReflow={handleThreshold}
              align='center'
              color='red'
              cone
              invert     
            />
          </group>
      </Box>  
    </>
  );
};

export default BioBox;